// extracted by mini-css-extract-plugin
export default {"wrapper":"FeedbackHomepage_wrapper__f+Gd+","likeAnimation":"FeedbackHomepage_likeAnimation__D-zvn"};